import TyumenOurHome from './container'

export default TyumenOurHome
